import React, { useEffect } from 'react';
import { Navbar } from 'flowbite-react';
import { useNavigate } from 'react-router-dom';
import { serverURL } from '../../constants';
import axios from 'axios';

const AdminHead = () => {

    const navigate = useNavigate();
    function redirectHome() {
        navigate("/home");
    }

    useEffect(() => {
        async function dashboardData() {
            const postURL = serverURL + `/api/dashboard`;
            const response = await axios.post(postURL);
            localStorage.setItem('adminEmail', response.data.admin.email);
            if (response.data.admin.email !== localStorage.getItem('email')) {
                redirectHome();
            }
        }
        if (localStorage.getItem('adminEmail')) {
            if (localStorage.getItem('adminEmail') !== localStorage.getItem('email')) {
                redirectHome();
            }
        } else {
            dashboardData();
        }
    }, []);

    return (
        <Navbar fluid className='py-5 dark:bg-black bg-white border-black dark:text-white dark:border-white md:border-b'>
            <p className='font-black text-xl'>Admin Panel</p>
        </Navbar>
    );
};

export default AdminHead;